import type { TFunction } from 'next-i18next'

import { MIXES, type TrackSource } from '@/constants/trackSources'

type TrackListHeadingMode = 'total' | 'selected'

const HEADING_KEYS = {
	track: {
		total: ['track-list.total-track', 'track-list.total-tracks'] as const,
		selected: [
			'track-list.selected-track',
			'track-list.selected-tracks',
		] as const,
	},
	mix: {
		total: ['track-list.total-mix', 'track-list.total-mixes'] as const,
		selected: ['track-list.selected-mix', 'track-list.selected-mixes'] as const,
	},
} as const

const getNounKey = (source: TrackSource): keyof typeof HEADING_KEYS =>
	source === MIXES ? 'mix' : 'track'

export const getTrackListHeadingText = (
	count: number,
	source: TrackSource,
	mode: TrackListHeadingMode,
	t: TFunction
): string => {
	const keys = HEADING_KEYS[getNounKey(source)][mode]
	const key = count === 1 ? keys[0] : keys[1]

	return t(key, { count })
}
